import { useCallback, useMemo, useState } from 'react';
import { presetDateKeysV89 } from '../../components/BillingDateCalendarV89';
import useTodayV97 from '../../hooks/useTodayV97';

export const resolveDateSelectionV97 = (selection, billingDay, today) =>
  selection.preset
    ? presetDateKeysV89(selection.preset, billingDay, new Date(today))
    : selection.dates;

export default function useBillingDateSelectionV97(scope, billingDay = 1) {
  const [today, refreshToday] = useTodayV97();
  const [selection, setSelection] = useState({
    scope,
    preset: 'today',
    dates: [],
  });
  // A different account/endpoint is a fresh view, even without an unmount.
  if (selection.scope !== scope) {
    refreshToday();
    setSelection({ scope, preset: 'today', dates: [] });
  }
  const dates = useMemo(
    () =>
      resolveDateSelectionV97(
        selection.scope === scope ? selection : { preset: 'today' },
        billingDay,
        today
      ),
    [billingDay, scope, selection, today]
  );
  const setDates = useCallback(
    (nextDates, { preset = null } = {}) => {
      refreshToday();
      setSelection({ scope, preset, dates: nextDates });
    },
    [refreshToday, scope]
  );
  return { dates, setDates, today, refreshToday, preset: selection.preset };
}
